import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import { GetUnloadingTimesRequestQuery, UnloadingTimesResponseData } from "../types/order"
import api from "../client"

const getData = async (getUnloadingTimesQueryParams: GetUnloadingTimesRequestQuery) => {
  const {
    unloadingDate,
    unloadingCountryCode,
    unloadingZIP,
    loadingCountryCode,
  } = getUnloadingTimesQueryParams
  const { data } = await api.get(`/unloadings/times/${loadingCountryCode}/${unloadingCountryCode}/${unloadingZIP}/${unloadingDate}`)
  return data
}

export const useUnloadingTimes = (
  getUnloadingTimesQueryParams: GetUnloadingTimesRequestQuery,
  isOrderEditable: boolean
): QueryObserverBaseResult<UnloadingTimesResponseData> => {

  const {
    unloadingCountryCode,
    loadingCountryCode,
    unloadingDate,
    unloadingZIP,
  } = getUnloadingTimesQueryParams

  const { data, ...props } = useQuery<UnloadingTimesResponseData>(
    queryKeys.UNLOADING_TIMES(getUnloadingTimesQueryParams),
    () => getData(getUnloadingTimesQueryParams),
    {
      enabled: Boolean(
        unloadingDate &&
        unloadingCountryCode &&
        unloadingZIP &&
        loadingCountryCode &&
        isOrderEditable
      )
    }
  )

  return { data, ...props }
}
